import { Text, TextProps } from "@chakra-ui/react";
import { ReactNode } from "react";

import { TEXT_STYLES, textStylesType } from "src/typography";

export type OFTextProps = TextProps & { children?: ReactNode; textStyle?: textStylesType };

export const OFText = ({ children, textStyle, ...props }: OFTextProps) => {
  const styles = textStyle ? TEXT_STYLES[textStyle] : TEXT_STYLES.body1;

  return (
    <Text fontFamily="graphik" color="inherit" {...styles} {...props}>
      {children}
    </Text>
  );
};
